import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { DataSource } from '@futrli-sdk/organisations';
import { updateWorkspaces, updateWorkspacesOrgWithSyncStatus } from '@futrli/shared-services';

import { useWorkspacesSelector } from './use-workspaces-selector';

export const useUpdateReduxOrgSyncStatus = (workspaceId: string, organisationId: string) => {
  const dispatch = useDispatch();
  const workspaces = useWorkspacesSelector();

  const updateOrgSyncStatus = useCallback(
    (datasource: DataSource) => {
      const updatedWorkspaces = updateWorkspacesOrgWithSyncStatus(workspaces, workspaceId, organisationId, datasource);
      return updateWorkspaces(updatedWorkspaces, dispatch);
    },
    [dispatch, organisationId, workspaceId, workspaces]
  );

  return { updateOrgSyncStatus };
};
